module.exports = __webpack_public_path__ + "static/media/twitter-hcr-grey.e2d7a796.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter-hcr-grey.svg
// module id = 1487
// module chunks = 0